import styled from 'styled-components/macro';

export const FloatingMessage = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 150px;
  font-size: ${({ theme }) => theme.h5}px;
  font-family: ${({ theme }) => theme.primaryFontLight};
  color: ${({ theme }) => theme.dark};
  text-align: center;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: ${({ width }) => width || 100}%;
  border: 10px solid ${({ theme }) => theme.mainGrey};
  padding: 20px 60px;
  background-color: ${({ theme }) => theme.white};

  @media (max-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
    width: 100vw;
    height: ${props => (props.height ? props.height : '100vh')};
    min-width: 0;
    border: 0;
    ${({ initialPosition }) => initialPosition && 'justify-content:flex-start;'}
  }
`;
